// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3_aYe","box":"WorkspacesBox_box__2VeYT","node":"WorkspacesBox_node__35iOt"};